function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="16" height="20" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg" {...props}><title>log-icon</title><g stroke="#6A6D7B" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><path d="M9.75 1h-7A1.75 1.75 0 0 0 1 2.75v14c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 15 16.75V6.25L9.75 1z" /><path d="M9.75 1v5.25H15M11.5 10.625h-7M11.5 14.125h-7M6.25 7.125H4.5" /></g></svg>;
});